import React, { Fragment, useState } from "react";
import { Button, SelectInput, Toolbar } from "react-admin";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import _ from "lodash";
import { isDisplayable } from "util/misc";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  details: {
    flexWrap: "wrap"
  },
  button: {
    marginRight: "20px",
    marginBottom: "10px"
  }
});

const PlayerAccordion = ({
  players = [],
  sortPlayers = false,
  getPlayerFields,
  namePath
}) => {
  const classes = useStyles();
  const [expandedList, setExpandedList] = useState([]);
  const [sortField, setSortField] = useState("lastName");

  const handleAccordionClick = (id) => (event) => {
    if (expandedList.includes(id)) {
      setExpandedList((expandedList) =>
        expandedList.filter((item) => item !== id)
      );
    } else {
      setExpandedList((expandedList) => [...expandedList, id]);
    }
  };

  const handleExpandAll = () => {
    setExpandedList(players.map((player) => player.id));
  };

  const handleCollapseAll = () => {
    setExpandedList([]);
  };

  const isAccordionExpanded = (id) => {
    return expandedList.includes(id);
  };

  const areAllCollapsed = expandedList.length === 0;
  const areAllExpanded = expandedList.length === players.length;

  // If the user is sorting by jersey number, sort numerically in ascending order
  // If it is something else and a string, sort by alpha
  // Default to numerical descending order in case we are sorting by points
  const sortPlayersByParam = (players) => {
    if (!sortField) return players;
    if (sortField === "jerseyNumber") {
      return players.sort((a, b) =>
        a[sortField] && !b[sortField]
          ? -1
          : !a[sortField] && b[sortField]
          ? 1
          : a[sortField] - b[sortField]
      );
    } else if (sortField === "lastName") {
      return players.sort((a, b) => {
        return a[sortField]?.localeCompare(b[sortField]);
      });
    } else {
      return players.sort((a, b) => b[sortField] - a[sortField]);
    }
  };

  return (
    <Fragment>
      {isDisplayable(players) && (
        <Toolbar>
          {!areAllCollapsed && (
            <Button
              className={classes.button}
              label="Collapse All"
              variant="outlined"
              onClick={handleCollapseAll}
            ></Button>
          )}
          {!areAllExpanded && (
            <Button
              className={classes.button}
              label="Expand All"
              variant="outlined"
              onClick={handleExpandAll}
            ></Button>
          )}
          {sortPlayers && (
            <SelectInput
              choices={[
                { id: "jerseyNumber", name: "Jersey Number" },
                { id: "lastName", name: "Last Name" }
              ]}
              initialValue="lastName"
              source="Sort by"
              onChange={(event) => {
                setSortField(event.target.value);
              }}
            />
          )}
          <br></br>
        </Toolbar>
      )}

      {sortPlayersByParam(players).map((player, i) => {
        return (
          <Accordion
            key={player.id}
            expanded={isAccordionExpanded(player.id)}
            onChange={handleAccordionClick(player.id)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              id={player.id}
              aria-controls={player.id}
            >
              {_.get(player, namePath)}{" "}
              {_.get(player, "jerseyNumber")
                ? " - " + _.get(player, "jerseyNumber")
                : ""}
            </AccordionSummary>
            <AccordionDetails
              className={`${classes.details} accordion-details`}
            >
              {getPlayerFields(i)}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Fragment>
  );
};

export default PlayerAccordion;
